/**
 * Settlement Upload Types
 * 정산서 업로드 관련 타입 정의
 */

// ======== 업로드 타입 (정산 구분) ========

/** 정산 업로드 타입 */
export type SettlementUploadType = 'PARTNER' | 'RIDER';

/** 정산 업로드 타입 라벨 */
export const SETTLEMENT_UPLOAD_TYPE_LABELS: Record<SettlementUploadType, string> = {
    PARTNER: '협력사 주정산',
    RIDER: '라이더 주정산',
};

// ======== 업로드 이력 테이블 ========

/** 업로드 이력 항목 */
export type SettlementUploadHistory = {
    /** 순번 */
    no: number;
    /** 업로드 ID (고유 식별자) */
    uploadId: string;
    /** 업로드 일자 */
    uploadDate: string;
    /** 적용일자 */
    applyDate: string;
    /** 정산기간 시작일 */
    settlementStartDate: string;
    /** 정산기간 종료일 */
    settlementEndDate: string;
    /** 협력사수 */
    supplierCount: number;
    /** 라이더수 */
    riderCount: number;
    /** 배달료 */
    deliveryFee: number;
    /** 후정산 */
    additionalSettlement: number;
    /** 관리비 */
    managementFee: number;
    /** 공급가액 */
    supplyAmount: number;
    /** 부가세액 */
    vatAmount: number;
    /** 시간제보험료 */
    hourlyInsurance: number;
    /** 적용여부 */
    isApplied: boolean;
    /** 업로드 타입 (협력사/라이더) */
    uploadType: SettlementUploadType;
    /** 업로드한 사용자 ID */
    uploadUserId?: string;
    /** 업로드한 사용자명 */
    uploadUserName?: string;
    /** 표시 이름 (예: 라이더 주정산, 협력사 주정산(재업로드 1)) */
    displayName?: string;
    /** 적용 가능 여부 (같은 정산기간에서 자신보다 나중 업로드가 적용되면 false) */
    canApply?: boolean;
};

// ======== API 요청 타입 ========

/** 업로드 이력 조회 요청 */
export type GetUploadHistoryRequest = {
    /** 조회 시작일 */
    startDate?: string;
    /** 조회 종료일 */
    endDate?: string;
    /** 업로드 타입 */
    uploadType?: SettlementUploadType;
};

/** 정산서 업로드 요청 (FormData로 전송) */
export type UploadSettlementRequest = {
    /** 엑셀 파일 */
    file: File;
    /** 업로드 타입 */
    uploadType: SettlementUploadType;
    /** 업로드한 사용자 ID */
    userId?: string;
};

/** 업로드 적용 요청 */
export type ApplyUploadRequest = {
    /** 업로드 ID */
    uploadId: string;
};

// ======== API 응답 타입 ========

/** 업로드 이력 조회 응답 */
export type GetUploadHistoryResponse = {
    /** 총 개수 */
    totalCount: number;
    /** 업로드 이력 목록 */
    histories: SettlementUploadHistory[];
};

/** 업로드 응답 */
export type UploadSettlementResponse = {
    /** 성공 여부 */
    success: boolean;
    /** 메시지 */
    message: string;
    /** 처리된 건수 */
    processedCount?: number;
    /** 업로드 ID (성공 시) */
    uploadId?: string;
};

/** 적용 응답 */
export type ApplyUploadResponse = {
    /** 성공 여부 */
    success: boolean;
    /** 메시지 */
    message: string;
};

// ======== 필터 상태 타입 ========

/** 업로드 이력 필터 상태 */
export type SettlementUploadFilters = {
    /** 조회 시작일 */
    startDate: string;
    /** 조회 종료일 */
    endDate: string;
    /** 업로드 타입 */
    uploadType: SettlementUploadType | 'ALL';
};
